export default "__VITE_ASSET__CsLuf_za__"